export const setAuth = (token, user) => {
  localStorage.setItem('token', token);
  localStorage.setItem('user', JSON.stringify(user));
};

export const auditLogout = () => {
  const t = localStorage.getItem('token');
  if (!t) return;
  try { fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/logout`, { method: 'POST', keepalive: true, headers: { Authorization: `Bearer ${t}` } }).catch(() => {}); } catch { /* noop */ }
};

export const clearAuth = () => {
  auditLogout();
  localStorage.removeItem('token');
  localStorage.removeItem('user');
};

export const getUser = () => {
  const userStr = localStorage.getItem('user');
  return userStr ? JSON.parse(userStr) : null;
};

export const getToken = () => {
  return localStorage.getItem('token');
};

export const isAuthenticated = () => {
  return !!getToken();
};

export const hasRole = (role) => {
  const user = getUser();
  return user?.role === role;
};

export const canEdit = () => {
  const user = getUser();
  return user?.role === 'admin' || user?.role === 'operador';
};

export const isAdmin = () => {
  return hasRole('admin');
};